import { Stack } from '@mui/material'
import { memo } from 'react'

import Text from '../shared/text/Text'

const LabelValue = ({ label, value, sx }) => {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      sx={{
        color: 'var(--layout-nav-text-primary-color)',
        bgcolor: 'background.neutral',
        borderRadius: 1.5,
        px: 2,
        py: 2,
        alignItems: 'center',
        justifyContent: 'space-between',
        ...sx
      }}
    >
      <Text variant='h5' label={label} />
      {value && (
        <Text
          variant='h5'
          fontWeight={700}
          label={value}
          sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
        />
      )}
    </Stack>
  )
}

export default memo(LabelValue)
